<template>
  <v-tooltip v-if="type" bottom>
    <template v-slot:activator="{ on }">
      <v-chip  v-on="on" :color="getStallholderColor(type)" dark>{{ type.charAt(0).toUpperCase() }}</v-chip>
    </template>
    <span>{{ type }}</span>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed : {
    ...mapGetters([
      'getStallholderColor'
    ]),
  }
}
</script>